import { useTranslation as useTranslationCore } from "@ubnt/store.core/lib/hooks/useTranslation";
import { Language } from "@ubnt/store.core/lib/types";
import EN_TRANSLATION from "../translations/en.json";

/**
 * By default format JS doesn't render XML tags within strings even tho' they are common rich text elements. As per
 * format.js docs suggestion create a preset-list
 * @see https://formatjs.io/docs/react-intl/components/#defaultrichtextelements
 */
export const DEFAULT_RICH_TEXT_ELEMENTS = {
  p: (chunks) => `<p>${chunks}</p>`,
  br: "<br />",
  hr: "<hr />",
  li: (chunks) => `<li>${chunks}</li>`,
  ul: (chunks) => `<ul>${chunks}</ul>`,
  strong: (chunks) => `<strong>${chunks}</strong>`,
};

export const useTranslation = () => {
  const { formatMessage: t } = useTranslationCore({
    defaultTranslation: EN_TRANSLATION,
    additionalTranslations: {
      [Language.Ar]: () =>
        import("translations/ar.json").then((res) => res.default),
      [Language.Ca]: () =>
        import("translations/ca.json").then((res) => res.default),
      [Language.Cs]: () =>
        import("translations/cs.json").then((res) => res.default),
      [Language.Da]: () =>
        import("translations/da.json").then((res) => res.default),
      [Language.Nl]: () =>
        import("translations/nl.json").then((res) => res.default),
      [Language.Fr]: () =>
        import("translations/fr.json").then((res) => res.default),
      [Language.De]: () =>
        import("translations/de.json").then((res) => res.default),
      [Language.El]: () =>
        import("translations/el.json").then((res) => res.default),
      [Language.It]: () =>
        import("translations/it.json").then((res) => res.default),
      [Language.Ja]: () =>
        import("translations/ja.json").then((res) => res.default),
      [Language.Ko]: () =>
        import("translations/ko.json").then((res) => res.default),
      [Language.No]: () =>
        import("translations/no.json").then((res) => res.default),
      [Language.Pl]: () =>
        import("translations/pl.json").then((res) => res.default),
      [Language.PtPt]: () =>
        import("translations/pt-pt.json").then((res) => res.default),
      [Language.EsMx]: () =>
        import("translations/es-mx.json").then((res) => res.default),
      [Language.Sv]: () =>
        import("translations/sv.json").then((res) => res.default),
      [Language.Tr]: () =>
        import("translations/tr.json").then((res) => res.default),
      // zh-Hans and zh-Hant-TW need to be investigated
      [Language.Zh]: () =>
        import("translations/zh.json").then((res) => res.default),
      [Language.Tw]: () =>
        import("translations/zh-tw.json").then((res) => res.default),
      [Language.PtBr]: () =>
        import("translations/pt-br.json").then((res) => res.default),
      [Language.Ru]: () =>
        import("translations/ru.json").then((res) => res.default),
      [Language.EsEs]: () =>
        import("translations/es-es.json").then((res) => res.default),
    },
  });

  return { t };
};
